import { BangCanDoiPhatSinhCongNoProvider, useBangCanDoiPhatSinhCongNoContext } from './context';
import InitialSearchDialog from './components/InitialSearchDialog';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { EditPrintTemplateDialog } from './components';
import { getTableColumns } from './cols-definition';
import ActionBar from './components/ActionBar';

function BangCanDoiPhatSinhCongNoPage() {
  const {
    isExporting,

    isLoading,
    data,
    currentPage,
    handlePageChange,
    totalItems,

    searchFieldStates,

    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleFixedColumnsClick,
    handleExportDataClick,

    selectedRowIndex,
    handleRowClick,
    clearSelection,

    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearchLogic,
    handleRefreshClickLogic,
    isSearching
  } = useBangCanDoiPhatSinhCongNoContext();

  const handleInitialSearch = async (formData: MuaHangRecord) => {
    try {
      await handleInitialSearchLogic(formData);
    } catch (error) {
      return;
    }
  };

  const handleRefreshClick = async () => {
    await handleRefreshClickLogic();
  };

  const handleCellClick = (row: MuaHangRecord) => {
    const supplierUuid = row.ma_kh_uuid || row.kh_uuid || row.ma_kh;
    if (!supplierUuid) {
      return;
    }

    const accountUuid = row.tk_uuid || row.tk;
    if (!accountUuid) {
      return;
    }

    const dataToSave = {
      ngay_ct1: searchParams?.ngay_ct1?.replaceAll('-', ''),
      ngay_ct2: searchParams?.ngay_ct2?.replaceAll('-', ''),
      kieu_xem: searchParams?.kieu_xem ?? 1,
      group_by: searchParams?.group_by,
      mau_bc: searchParams?.mau_bc ?? 20,
      tk: accountUuid,
      ma_kh: supplierUuid,
      tk_data: {
        uuid: accountUuid,
        code: row.tk,
        name: row.ten_tk
      },
      kh_data: {
        uuid: supplierUuid,
        customer_code: row.ma_kh,
        customer_name: row.ten_kh
      }
    };

    localStorage.setItem('bang-can-doi-phat-sinh-cong-no-payload', JSON.stringify(dataToSave));

    const url = `/mua-hang/cong-no-nha-cung-cap/so-chi-tiet-cong-no-theo-nha-cung-cap/?ma_kh=${supplierUuid}`;
    window.open(url, '_blank');
  };

  const tables = [
    {
      name: '',
      rows: (hasFilterParams ? searchState.searchResults : data) || [],
      columns: getTableColumns(handleCellClick)
    }
  ];

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {initialSearchDialogOpen && (
        <InitialSearchDialog
          open={initialSearchDialogOpen}
          onClose={handleInitialSearchClose}
          onSearch={handleInitialSearch}
          searchFieldStates={searchFieldStates}
          searchParams={searchParams}
        />
      )}
      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            searchParams={searchParams}
            account={searchFieldStates.account}
          />

          <div className='w-full overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                selectedRowId={selectedRowIndex || undefined}
                totalItems={hasFilterParams ? searchState.totalCount : totalItems}
                pageSize={50}
                currentPage={hasFilterParams ? searchState.currentPage : currentPage}
                onPageChange={async (page: number) => {
                  clearSelection();
                  if (hasFilterParams) {
                    handleSearchPageChange(page);
                  } else {
                    await handlePageChange(page);
                  }
                }}
                onSearchChange={handleSearchChange}
                loading={isLoading || isSearching}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default function BangCanDoiPhatSinhCongNoPageContent() {
  return (
    <BangCanDoiPhatSinhCongNoProvider>
      <BangCanDoiPhatSinhCongNoPage />
    </BangCanDoiPhatSinhCongNoProvider>
  );
}
